import React from 'react';
import { ChatError as ChatErrorInfo } from '../../types/IAiConversation';

const headlineOf = (kind: ChatErrorInfo['kind']): string => {
  if (kind === 'network') return "Couldn't reach the assistant";
  if (kind === 'timeout') return 'The response timed out';
  return "The assistant couldn't complete this request";
};

interface IProps {
  error: ChatErrorInfo;
  canRetry: boolean;
  onRetry?: () => void;
}

// A failed turn, under whatever partial answer arrived before it failed.
const ChatError = ({ error, canRetry, onRetry }: IProps) => (
  <div className="chat-error" role="alert">
    <b>{headlineOf(error.kind)}</b>
    <div className="chat-error-guidance">
      {error.kind === 'network' || error.kind === 'timeout'
        ? 'Check the connection and try again.'
        : 'You can try again, or rephrase the question.'}
    </div>
    {onRetry ? (
      <button
        type="button"
        className="btn-app btn-app--outline btn-app--sm"
        onClick={onRetry}
        disabled={!canRetry}
      >
        Retry
      </button>
    ) : null}
    {error.kind === 'server' || error.kind === 'http' ? (
      <details>
        <summary>Details</summary>
        {error.message}
      </details>
    ) : null}
  </div>
);

export default ChatError;
